<template>
  <div class="ma-0 pa-0" style="background: transparent">
    <v-row class="ma-0 pa-0 mt-2 mb-n2" justify="center"
      ><p
        style="
          font-size: 40px;
          font-family: Raleway;
          font-weight: 900 !important;
        "
      >
        {{ pageTitle }}
      </p></v-row
    >
    <div class="md-layout" style="background: transparent">
      <div
        :class="gridViewLayout"
        v-for="(item, index) in sharePageFiles"
        :key="index"
      >
        <div class="ma-0 pa-0 mx-10 mb-10" style="background: transparent">
          <model-viewer
            :style="gridViewViewerStyle"
            id="loading-demo-sub"
            :src="item.fileglb"
            :ios-src="item.fileusdz"
            :poster="item.filepng"
            reveal="interaction"
            background-color="transparent"
            interaction-prompt="none"
            environment-image="neutral"
            camera-controls
            ar
            ar-modes="webxr scene-viewer quick-look"
            ar-scale="auto"
            alt="A 3D model of an astronaut"
            ><button
              slot="ar-button"
              style="
                background-color: white;
                border-radius: 4px;
                border: none;
                position: absolute;
                top: 16px;
                right: 16px;
              "
            >
              Activate AR
            </button>
          </model-viewer>
          <div class="ma-0 pa-0 mx-5 mt-10" style="font-family: Nunito Sans">
            <div class="ma-0 pa-0" v-if="item.filename">
              <p style="font-weight: 800">File Name</p>
              <div
                class="ma-0 pa-0 mt-n2"
                style="line-height: 1.3; opacity: 0.8"
              >
                <p>{{ item.filename }}</p>
                <p class="mt-n3">Version {{ item.version }}</p>
              </div>
            </div>
            <div class="ma-0 pa-0" v-else style="display: flex">
              <p style="font-weight: 800; opacity: 0.4">File Name</p>
              <v-divider class="ml-3 mt-3" height="30"></v-divider>
            </div>
            <div class="ma-0 pa-0" v-if="item.description">
              <p class="mt-6" style="font-weight: 800">File Description</p>
              <div
                class="ma-0 pa-0 mt-n2"
                style="line-height: 1.3; opacity: 0.8"
              >
                <p>{{ item.description }}</p>
              </div>
            </div>
            <div class="ma-0 pa-0 mt-6" v-else style="display: flex">
              <p style="font-weight: 800; opacity: 0.4">File Description</p>
              <v-divider class="ml-3 mt-3" height="30"></v-divider>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "sharePage",
  components: {},
  props: {
    grids: { type: String, default: "1" },
    pageTitle: { type: String, default: "Houseware" },
    passwordRequired: { type: Boolean, default: true },
    sharePageFiles: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data: function () {
    return {
      gridViewLayout: "",
      gridViewViewerStyle: "",
    };
  },
  mounted() {
    if (this.grids === "1") {
      this.gridViewLayout =
        "md-layout-item md-medium-size-100 md-small-size-100 md-size-100";
      this.gridViewViewerStyle = "width: 100%; min-height: 850px; height: 90%;";
    } else if (this.grids === "2") {
      this.gridViewLayout =
        "md-layout-item md-medium-size-100 md-small-size-100 md-size-50";
      this.gridViewViewerStyle = "width: 100%; min-height: 550px; height: 90%;";
    } else if (this.grids === "3") {
      this.gridViewLayout =
        "md-layout-item md-medium-size-100 md-small-size-100 md-size-33";
      this.gridViewViewerStyle = "width: 100%; min-height: 400px; height: 90%;";
    }
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Raleway:200,300,400,600,700,800,900");
@import url("https://fonts.googleapis.com/css?family=Nunito Sans:200,300,400,600,700,800,900");

model-viewer#loading-demo-sub {
  --poster-color: transparent;
}
</style>